import { useEffect } from 'react';

const SITE_NAME = 'Direwolf AI account';

export function documentTitle(title: string): string {
  return `${title} · ${SITE_NAME}`;
}

/** Sets the document title (WCAG 2.4.2); null leaves it alone. */
export function usePageTitle(title: string | null): void {
  useEffect(() => {
    if (title !== null) document.title = documentTitle(title);
  }, [title]);
}

/*
 * Focus on navigation: the first page heading of a document load keeps focus where the browser put
 * it; every later one (another page, or a new state of the same page) takes focus, so screen-reader
 * and keyboard users start at the top of what changed.
 */
let headingsShown = 0;

export function headingShownBefore(): boolean {
  return headingsShown > 0;
}

export function markHeadingShown(): void {
  headingsShown += 1;
}

/** Tests: the next heading counts as the first of a page load again. */
export function resetHeadingFocus(): void {
  headingsShown = 0;
}
